/**
 * Combines multiple class names into a single string
 * @param {string[]} inputs - Class names to combine
 * @returns {string} - Combined class names
 */
export function cn(...inputs) {
  return inputs.filter(Boolean).join(' ');
}

/**
 * Convert a stored sentiment score (-1.0..1.0 float, or numeric string) to its
 * -100..100 display integer. Returns null when the value is missing/non-numeric.
 * @param {number|string|null} score
 * @returns {number|null}
 */
export function sentimentToPct(score) {
  if (score == null) return null;
  const pct = typeof score === 'number' ? Math.round(score * 100) : parseInt(score);
  return isNaN(pct) ? null : pct;
}

/**
 * Clamp a -100..100 display integer to a stored -1.0..1.0 float.
 * @param {number|string} value
 * @returns {number}
 */
export function pctToSentiment(value) {
  return Math.max(-100, Math.min(100, Math.round(Number(value) || 0))) / 100;
}

/**
 * Color per dominant emotion, shared across screens (post tiles, comment rows).
 * Covers the full emotion set emitted by the analyzers.
 */
export const EMOTION_COLORS = {
  joy: '#30d158', anger: '#ff453a', sadness: '#5ac8fa', fear: '#af52de',
  surprise: '#ffcc00', disgust: '#ff9500', trust: '#34c759', anticipation: '#ff9f0a',
  neutral: '#8e8e93',
};

/**
 * Map a stored sentiment score (-1.0..1.0) to a status color, matching the
 * threshold style used on post tiles. Returns null when the score is missing.
 * @param {number|null} score
 * @returns {string|null}
 */
export function sentimentDotColor(score) {
  if (score == null) return null;
  if (score > 0.3) return '#30d158';
  if (score < -0.3) return '#ff453a';
  return '#8e8e93';
}
